import { concatClasses } from "../../../helpers/concatClasses/index.js";
const getClasses = (cmp) => {
  var _a, _b, _c, _d;
  const isHorizontal = ((_a = cmp.tabsCtx) == null ? void 0 : _a.direction) === "horizontal";
  const isSelected = ((_b = cmp.tabsCtx) == null ? void 0 : _b.value) === cmp.dsf_slot;
  const classes = [
    "group",
    "flex",
    "grow",
    "relative",
    "cursor-pointer",
    "hover:bg-neutral-50",
    "focus:bg-neutral-50",
    "transition-colors",
    "items-center",
    "justify-between",
    "overflow-hidden",
    "content-center",
    "outline-none"
  ];
  if (isHorizontal) {
    classes.push("px-8", "py-12", "rounded-t-s");
  } else {
    classes.push("py-8", "px-12");
  }
  classes.push(
    "after:absolute",
    "after:opacity-0",
    "after:transition-opacity",
    "hover:after:opacity-100",
    "focus:after:opacity-100"
  );
  if (isHorizontal) {
    classes.push("after:-bottom-1", "after:left-0", "after:right-0");
    if (((_c = cmp.tabsCtx) == null ? void 0 : _c.size) === "small") {
      classes.push("after:h-2");
    } else {
      classes.push("after:h-3");
    }
  } else {
    classes.push("after:-left-1", "after:top-0", "after:bottom-0");
    if (((_d = cmp.tabsCtx) == null ? void 0 : _d.size) === "small") {
      classes.push("after:w-2");
    } else {
      classes.push("after:w-3");
    }
  }
  if (isSelected) {
    classes.push("after:bg-secondary-300", "after:opacity-100");
    if (isHorizontal) {
      classes.push("after:rounded-ss-sm", "after:rounded-se-sm");
    } else {
      classes.push("after:rounded-br-sm", "after:rounded-tr-sm");
    }
  } else {
    classes.push("after:bg-neutral-100");
  }
  return concatClasses(classes);
};
const getIconClasses = (cmp) => {
  var _a;
  const classes = ["mr-8", "mt-2"];
  switch ((_a = cmp.tabsCtx) == null ? void 0 : _a.size) {
    case "small":
      classes.push("h-12 w-12");
      break;
    case "large":
      classes.push("h-16 w-16");
      break;
    case "medium":
    default:
      classes.push("h-14 w-14");
  }
  return concatClasses(classes);
};
const getTitleSize = (cmp) => {
  var _a;
  switch ((_a = cmp.tabsCtx) == null ? void 0 : _a.size) {
    case "small":
      return "xxs";
    case "large":
      return "s";
    case "medium":
    default:
      return "xs";
  }
};
const getSubtitleSize = (cmp) => {
  var _a;
  switch ((_a = cmp.tabsCtx) == null ? void 0 : _a.size) {
    case "small":
      return "xxs";
    case "large":
      return "xs";
    case "medium":
    default:
      return "xxs";
  }
};
const getBadgeClasses = (cmp) => {
  var _a, _b;
  const classes = [];
  if (((_a = cmp.tabsCtx) == null ? void 0 : _a.size) === "small") {
    classes.push("ml-2");
  } else {
    classes.push("ml-4");
  }
  if (((_b = cmp.tabsCtx) == null ? void 0 : _b.direction) === "vertical") {
    classes.push(
      "pl-48",
      "group-hover:pl-38",
      "group-hover:mr-10",
      "group-focus:pl-38",
      "group-focus:mr-10",
      "ease-out",
      "duration-[250ms]",
      "transition-all"
    );
  }
  return concatClasses(classes);
};
const getVerticalArrowClasses = () => {
  const classes = [
    "duration-[250ms]",
    "ease-out",
    "transition-all",
    "absolute",
    "-right-16",
    "h-0",
    "w-0",
    "group-hover:right-0",
    "group-hover:h-16",
    "group-hover:w-16",
    "group-hover:mr-6",
    "group-focus:right-0",
    "group-focus:h-16",
    "group-focus:w-16",
    "group-focus:mr-6"
  ];
  return concatClasses(classes);
};
const getTitleClasses = (cmp) => {
  var _a;
  const classes = [];
  if (((_a = cmp.tabsCtx) == null ? void 0 : _a.direction) === "vertical") {
    classes.push("pr-12");
  }
  return concatClasses(classes);
};
export {
  getBadgeClasses,
  getClasses,
  getIconClasses,
  getSubtitleSize,
  getTitleClasses,
  getTitleSize,
  getVerticalArrowClasses
};
